import { $children as i } from "../../utils/gogocodeTransfer.js";
function p(o, a, n) {
  i(this).forEach((t) => {
    var e = t.$options.componentName;
    e === o ? t.$emit.apply(t, [a].concat(n)) : p.apply(t, [o, a].concat([n]));
  });
}
const c = {
  methods: {
    dispatch(o, a, n) {
      for (var t = this.$parent || this.$root, e = t.$options.componentName; t && (!e || e !== o); )
        t = t.$parent, t && (e = t.$options.componentName);
      t && t.$emit.apply(t, [a].concat(n));
    },
    broadcast(o, a, n) {
      p.call(this, o, a, n);
    }
  }
};
export {
  c as default
};
